module.exports = __webpack_public_path__ + "img/Motorisation FAAC.a79ae970.jpg";